module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-300-[67]66.c1f4674.woff2";